const apiUrl = process.env.REACT_APP_API_URL;

export async function ApplyJavamonAbility(idItemInstance: number, idJavamonInstance: number) {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/javamon/ability`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ idItemInstance, idJavamonInstance })
        });
        return await response.ok;
    } catch (error) {
        console.error("Error applying javamon ability:", error);
        return false;
    }
}
